module.exports = __webpack_public_path__ + "static/logo-6b40c9a73718691b31ec40e227bd4764.svg";